module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"average":"Average","pageTitle":"Progress of paths for group","returnToList":"Return to list","trainingPaths":"paths"},"fr":{"average":"Moyenne","pageTitle":"Avancement des parcours pour le groupe","returnToList":"Retour à la liste","trainingPaths":"parcours"}}')
  delete Component.options._Ctor
}
